import { Input, Modal, ModalBody, Spinner } from 'reactstrap';
import ErrorMessage from '../common/ErrorMessage';
import CrossIcon from '../Icons/CrossIcon';
import DeleteIcon from '../Icons/DeleteIcon';
import { useState } from 'react';
import Button from '../ui/Button';
interface IConfirmModalProps {
  isOpen: boolean;
  toggle: () => void;
  submitHandler: (reason?: string) => void;
  isLoading?: boolean;
  confirmReason?: string;
  hideReason?: boolean;
}
const ConfirmModal = ({
  isOpen,
  toggle,
  confirmReason,
  submitHandler,
  isLoading,
  hideReason,
}: IConfirmModalProps) => {
  const [reason, setReason] = useState<string>('');
  const [error, setError] = useState<string>('');
  const handleSubmit = () => {
    if (confirmReason && !hideReason) {
      if (reason.length === 0) {
        setError('Reason is required');
        return;
      }
      submitHandler(reason);
    } else {
      submitHandler();
    }
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalBody className="text-center ">
        <div className="d-flex flex-column justify-items-center align-items-center gap-4">
          <span className="icon">
            {confirmReason ? <CrossIcon /> : <DeleteIcon />}
          </span>

          {/* {!Reason && <h2>Are you sure ?</h2>} */}
          <p className="mb-4">
            Do you really want to {confirmReason ? 'Reject' : 'delete'} ?
          </p>
          {(confirmReason && !hideReason) && (
            <div className="col-12">
              <div className="d-flex flex-column">
                <label htmlFor="firstName" className="form-label text-start">
                  Reason
                  <span className="text-danger">*</span>
                </label>
                <Input
                  type="text"
                  className=" w-100"
                  placeholder="Reason"
                  id="firstName"
                  aria-describedby="emailHelp"
                  onChange={(e) => {
                    if (e.target.value) {
                      setReason(e.target.value);
                      setError('');
                    }
                  }}
                />
                <ErrorMessage message={error} />
              </div>
            </div>
          )}

          {/* Buttons */}
          <div className="row m-0 w-100">
            <div className="col-12 col-md-6 ps-0 pe-3">
              <button
                type="button"
                className="btn btn-secondary w-100"
                onClick={toggle}
              >
                Cancel
              </button>
            </div>
            <div className="col-12 col-md-6 pe-0 ps-3">
              <Button
                className={'btn btn-danger w-100 '}
                onClick={handleSubmit}
                disabled={isLoading}
                type="button"
              >
                {isLoading ? (
                  <Spinner color="light" />
                ) : confirmReason ? (
                  'Reject'
                ) : (
                  'Delete'
                )}
              </Button>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
export default ConfirmModal;
